const REASON_KEY = "auth_redirect_reason";
const FROM_KEY = "auth_redirect_from";

/** Store context then redirect to a clean `/session-timeout` URL (no query string). */
export function redirectToSessionTimeoutPage({ reason, from } = {}) {
  if (typeof sessionStorage !== "undefined") {
    if (reason) sessionStorage.setItem(REASON_KEY, reason);
    else sessionStorage.removeItem(REASON_KEY);
    if (from) sessionStorage.setItem(FROM_KEY, from);
    else sessionStorage.removeItem(FROM_KEY);
  }
  return "/session-timeout";
}

/** Read and clear one-time redirect context (used by SessionTimeout page). */
export function consumeAuthRedirectContext() {
  if (typeof sessionStorage === "undefined") {
    return { reason: null, from: null };
  }
  const reason = sessionStorage.getItem(REASON_KEY);
  const from = sessionStorage.getItem(FROM_KEY);
  sessionStorage.removeItem(REASON_KEY);
  sessionStorage.removeItem(FROM_KEY);
  return { reason, from };
}

/** @deprecated Use redirectToSessionTimeoutPage — kept for backwards-compatible URLs with ?reason= */
export function buildSessionTimeoutUrl(opts) {
  return redirectToSessionTimeoutPage(opts);
}
